// extracted by mini-css-extract-plugin
export var messageSideLeft = "_kv-1";
export var messageSideRight = "_kv-2";
export var subscribeToBackInStockBubbleContainer = "_kv-0";